module.exports = __webpack_public_path__ + "img/icon2.48238a13.jpg";